module.exports = __webpack_public_path__ + "static/media/speech_13.2f97c105.svg";